<template>
<div>
        <h2 class="text-center text-primary">Танзим</h2>


 

    <div class="row">
        <div class="col-sm-6">

    <div class="card shadow">
                <div class="card-header bg-primary text-white">
            Раис
  </div>
  <div class="card-body">

            <div class="form-group">
                <label for="exampleInputEmail1">Ному насаб</label>
                <input type="text" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" v-model="setting.Rais" >
            </div>
            <div class="form-group">
                <label for="exampleInputPassword1">Телефон</label>
                <input type="text" class="form-control" id="exampleInputPassword1" v-model="setting.Phone">
            </div>
        </div>
    </div>
</div>



             
                <div class="col-sm-6">


    <div class="card shadow">
  <div class="card-header bg-primary text-white">
            Котиб
  </div>
  <div class="card-body">

            <div class="form-group">
                <label for="exampleInputEmail1">Ному насаб</label>
                <input type="text" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" v-model="setting.Kotib" >
            </div>
            <div class="form-group">
                <label for="exampleInputPassword1">Телефон</label>
                <input type="text" class="form-control" id="exampleInputPassword1" v-model="setting.Phone2" >
            </div>
        </div>
    </div>


  </div>



</div>


    <div class="row">
        <div class="col-sm-6">

    <div class="card shadow">
                <div class="card-header bg-primary text-white">
            Шахси иловагии 1-ум
  </div>
  <div class="card-body">

            <div class="form-group">
                <label for="exampleInputEmail1">Вазифа</label>
                <input type="text" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" v-model="setting.Job1" >
            </div>
            <div class="form-group">
                <label for="exampleInputPassword1">Ному насаб</label>
                <input type="text" class="form-control" id="exampleInputPassword1" v-model="setting.Name1">
            </div>
        </div>
    </div>
</div>



             
                <div class="col-sm-6">


    <div class="card shadow">
  <div class="card-header bg-primary text-white">
            Шахси иловагии 2-юм
  </div>
  <div class="card-body">

            <div class="form-group">
                <label for="exampleInputEmail1">Вазифа</label>
                <input type="text" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" v-model="setting.Job2" >
            </div>
            <div class="form-group">
                <label for="exampleInputPassword1">Ному насаб</label>
                <input type="text" class="form-control" id="exampleInputPassword1" v-model="setting.Name2" >
            </div>
        </div>
    </div>


  </div>



</div>


    <button type="button" @click="save" class="btn btn-primary mt-3">Сабткунӣ</button>


 
</div>
</template>



<script>
 

export default {

data(){

    return{

        setting:{
         
        }

    }
},

 methods:{

async GetReport(terid){

console.log('start report3');
try{
                    await this.$api("/api/summary/"+5+"/"+terid+" /")
                  //  .then(res => res.json())
                    .then(data => this.list=data)
                    .catch(error => {
                          console.error("There was an error!", error)
                    });

                    console.log('stop report3');
}
catch(ex){
console.log(ex);

}
finally{
console.log('finish');

}

},

refresh(h){

  

this.GetReport(h);

},

async save(){

console.log('start save setting');

  const requestOptions = {
    method: "Put",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(this.setting)
  };
                   await this.$api("/api/data/1",  requestOptions)
            .then(  this.$router.push('/'))
                    .catch(error => {
                          console.error("There was an error!", error)
                    });

                    console.log('stop save setting');

},

async fetchSetting() {
      console.log("start2",this.$store.state.household.ID);
    
      this.$store.state.members='';
      console.log('before fetch setting');
      await this.$api(
        "/api/data/6/" + this.$store.state.terid
      )
      // .then((res) => res.json())
        .then((data) => (this.setting = data))
        .catch((error) => {
          console.error("There was an error!", error);
        });

      console.log("after fetch setting");

  
    },




},

mounted(){

    this.fetchSetting();
}



}
</script>
